var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.408163,
    y: 79.5918,
    width: 79.1837,
    height: 79.1837,
    rx: 39.5918,
    transform: "rotate(-90 0.408163 79.5918)",
    stroke: "#575757",
    strokeWidth: 0.816326
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4419_239186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6828 28.3096L50.1016 40.1953L38.6828 52.0811L38.1522 51.5717L48.7007 40.5986L29.4714 40.5986L29.4714 39.877L48.7644 39.877L38.1522 28.819L38.6828 28.3096Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4419_239186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1551,
    height: 21.2245,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 50.6094 52.0815)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessicon1);
export default __webpack_public_path__ + "static/media/processicon1.be87bec662c5355dbf43190a39c42302.svg";
export { ForwardRef as ReactComponent };